// src/auth/api.js
import axios from 'axios';
import { useAuth } from './AuthContext';
import { useMemo } from 'react';

export function useApi() {
  const { token, checkAndRefreshToken, logout } = useAuth();

  // SOLO crea el api e interceptores si cambia el token
  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    });

    instance.interceptors.request.use(
      async (config) => {
        await checkAndRefreshToken();
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      },
      error => Promise.reject(error)
    );

    instance.interceptors.response.use(
      response => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, [token, checkAndRefreshToken, logout]); // Solo cambia si cambian estos

  return api;
}
